import { makeStyles } from '@material-ui/core';
import { green, grey, blue, red, teal } from '@material-ui/core/colors';

const style = {
  proposed: {
    background: teal['100']
  },
  declined: {
    background: red['A200']
  },
  approved: {
    background: teal['200']
  },
  passive: {
    background: grey['A100']
  },
  active: {
    background: blue['A100']
  },
  completed: {
    background: green['A100']
  },
  failed: {
    background: red['A100']
  },
  unknown: {
    background: grey['A400']
  },
  button: {
    margin: '10px 10px 20px 0px'
  },
  'in-danger': {
    background: '#F48401'
  },
  neutral: {
    background: '#3498DB'
  },
  awesome: {
    background: '#1ABC9C'
  },
  chip: {
    marginLeft: '5px'
  }
};

const useStatusStyles = makeStyles(style);

export default useStatusStyles;
